import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { sendMessage } from '@/features/internal/patient-messaging/apis/patientMessagingApi'
import { LineMessage } from '@/features/internal/patient-messaging/types/patientMessaging'

interface SendMessageVariables {
  threadId: string
  content: string
}

export const useSendMessageMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      threadId,
      content,
    }: SendMessageVariables): Promise<LineMessage> => {
      return await sendMessage(threadId, content)
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.patientMessaging.thread(variables.threadId),
      })
    },
  })
}
